import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { authService } from '../../services/api';
import './Login.css';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('request'); // 'request' or 'confirmation'

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await authService.requestPasswordReset(email);
      setMessage('Un email avec les instructions de réinitialisation a été envoyé à votre adresse email.');
      setStep('confirmation');
    } catch (err) {
      setError(err.response?.data?.detail || 'Une erreur est survenue. Veuillez réessayer plus tard.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page py-5 mt-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="login-card">
              <Card.Body>
                <div className="text-center mb-4">
                  <h2 className="login-title">Réinitialisation du mot de passe</h2>
                  {step === 'request' ? (
                    <p className="login-subtitle">Entrez votre email pour réinitialiser votre mot de passe</p>
                  ) : (
                    <p className="login-subtitle">Vérifiez votre boîte de réception</p>
                  )}
                </div>
                
                {error && (
                  <Alert variant="danger">
                    {error}
                  </Alert>
                )}
                
                {message && (
                  <Alert variant="success">
                    {message}
                  </Alert>
                )}
                
                {step === 'request' ? (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label>Adresse Email</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="fas fa-envelope"></i>
                        </span>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Entrez votre email"
                          value={email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </Form.Group>
                    
                    <Button 
                      variant="primary" 
                      type="submit" 
                      className="w-100 login-btn" 
                      disabled={loading}
                    >
                      {loading ? 'Envoi en cours...' : 'Réinitialiser le mot de passe'}
                    </Button>
                  </Form>
                ) : (
                  <div className="text-center">
                    <p>Nous avons envoyé un email à <strong>{email}</strong> avec les instructions pour réinitialiser votre mot de passe.</p>
                    <p>Si vous ne recevez pas l'email dans les prochaines minutes, vérifiez votre dossier spam ou essayez à nouveau.</p>
                  </div>
                )}
                
                <div className="text-center mt-4">
                  <p className="mb-0">
                    <Link to="/login" className="register-link">Retour à la connexion</Link>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ResetPassword;